import service from '@/utils/request.js';

const account = {
  state: {
    accountid: '',
    name: '',
    address: '',
    betreuer: '',
    betriebsrat: false,
    aiEnabled: false,
    email: '',
    restSubscription: null,
    crmID: null,
    dsko: '',
    dsb: '',
    website: '',
    phone: '',
    aufsichtsbehoerde: '',
    departments: [],
    personGroups: [],
    systems:[],
    dataTypes: [],
    suppliers: [],
    abbreviations: [],
    systemWarnings: [],
    taskWarnings: []
  },

  actions: {
    async fetchAccountByShortName({commit}, short_name){
      const response = await service.get(`todos/v1/accounts/?account_id=${short_name}`);
      if (response.data.count === 1) commit("SET_ACCOUNT", response.data.results[0])
    },
  },

  mutations: {
    SET_ACCOUNT_ID: (state, id) => {
      state.accountid = id
    },
    SET_ACCOUNT_NAME: (state, name) => {
      state.name = name
    },
    SET_ACCOUNT_ADDRESS: (state, address) => {
      state.address = address
    },
    SET_ACCOUNT_BETREUER: (state, betreuer) => {
      state.betreuer = betreuer
    },
    SET_BETRIEBSRAT: (state, betriebsrat) => {
      state.betriebsrat = betriebsrat
    },
    SET_AIENABLED: (state, aiEnabled) => {
      state.aiEnabled = aiEnabled
    },
    SET_EMAIL: (state, email) => {
      state.email = email
    },
    SET_REST_SUBSCRIPTION: (state, subscription) => {
      state.restSubscription = subscription
    },
    SET_CRM_ID: (state, crmID) => {
      state.crmID = crmID
    },
    SET_DSKO: (state, DSKO) => {
      state.dsko = DSKO
    },
    SET_AUFSICHTSBEHOERDE: (state, aufsichtsbehoerde) => {
      state.aufsichtsbehoerde = aufsichtsbehoerde
    },
    SET_DEPARTMENTS: (state, departments) => {
      state.departments = departments
    },
    SET_SYSTEMS: (state, systems) => state.systems = systems,
    SET_PERSONGROUPS: (state, personGroups) => state.personGroups = personGroups,
    SET_DATATYPES: (state, dataTypes) => state.dataTypes = dataTypes,
    SET_SUPPLIERS: (state, suppliers) => state.suppliers = suppliers,
    SET_ABBREVIATIONS: (state, abbreviations) => state.abbreviations = abbreviations,
    SET_SYSTEM_WARNINGS: (state, systemWarnings) => state.systemWarnings = systemWarnings,
    SET_TASK_WARNINGS: (state, taskWarnings) => state.taskWarnings = taskWarnings,
    SET_ACCOUNT: (state, item) => {
      state.accountid = item.id
      state.name = item.name
      state.address = item.address
      state.betreuer = item.betreuer
      state.betriebsrat = item.betriebsrat
      state.email = item.email
      state.dsb = item.dsb
      state.website = item.website
      state.phone = item.phone
      state.restSubscription = item.restSubscription
      state.crmID = item.crmID
      state.dsko = item.dsko
      state.aufsichtsbehoerde = item.aufsichtsbehoerde
      state.aiEnabled = item.aiEnabled
    },
    RESET_ACCOUNT: (state) => {
      state.accountid = ''
      state.name = ''
      state.address = ''
      state.betreuer = ''
      state.betriebsrat = false
      state.aiEnabled = false
      state.email = ''
      state.dsb = ''
      state.website = ''
      state.phone = ''
      state.restSubscription = ''
      state.crmID = ''
      state.dsko = ''
      state.aufsichtsbehoerde = ''
      state.departments = []
      state.systems = []
      state.personGroups = []
      state.dataTypes = []
      state.abbreviations = []
    }
  }
}

export default account
